module.exports = __webpack_public_path__ + "static/media/meet-piper-tablet-en.92609bd6.svg";